import { createContext, useReducer } from "react";
import inputReducer, { initialInput } from "../reducer/LoginReducer";

export const LoginContext = createContext(initialInput);

export const LoginProvider = ({ children }) => {
  const [input, dispatch] = useReducer(inputReducer, initialInput);
  //const emailRule = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
  const emailRule = /^\S.{5,}$/;
  const phoneNumberRule = /^09\d{8}$|^$/;
  const passwordRule = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
  const validateMailValue = (value) => emailRule.test(value);
  const validatePhoneValue = (value) => phoneNumberRule.test(value);
  const validatePasswordValue = (value) => passwordRule.test(value);
  const mailValueIsValid = input.mailValue==""? false: validateMailValue(input.mailValue);
  const phoneValueIsValid = input.phoneValue==""? false: validatePhoneValue(input.phoneValue);
  const passwordValueIsValid = validatePasswordValue(input.passwordValue);

  const hasMailError = !mailValueIsValid && input.mailIsTouched;
  const hasPhoneError = !phoneValueIsValid && input.phoneIsTouched;
  const hasPasswordError = !passwordValueIsValid && input.passwordIsTouched;

  const onChangeMailValue = (e) => {
    dispatch({ type: "MAIL_INPUT", mailValue: e.target.value });
  };
  const onChangePasswordValue = (e) => {
    dispatch({ type: "PASSWORD_INPUT", passwordValue: e.target.value });
  };
  const onChangePhoneValue = (e) => {
    dispatch({ type: "PHONE_INPUT", phoneValue: e.target.value });
  };

  const onBlurMailValue = () => {
    dispatch({ type: "MAIL_BLUR" });
  };

  const onBlurPasswordValue = () => {
    dispatch({ type: "PASSWORD_BLUR" });
  };

  const onBlurPhoneValue = () => {
    dispatch({ type: "PHONE_BLUR" });
  };

  const reset = () => {
    dispatch({ type: "RESET" });
  };
  const resetPassword = () => {
    dispatch({ type: "RESET_PASSWORD" });
  };

  const value = {
    mailValue: input.mailValue,
    passwordValue: input.passwordValue,
    phoneValue: input.phoneValue,
    mailValueIsValid,
    passwordValueIsValid,
    phoneValueIsValid,
    hasMailError,
    hasPasswordError,
    hasPhoneError,
    onChangeMailValue,
    onChangePasswordValue,
    onChangePhoneValue,
    onBlurMailValue,
    onBlurPasswordValue,
    onBlurPhoneValue,
    resetPassword,
    reset,
  };
 
  return (
    <LoginContext.Provider value={value}>{children}</LoginContext.Provider>
  );
};
